import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { Button } from '@/shared/components/atoms';
import { EmptyCard } from '@/shared/components/molecules';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import File from '~/images/shared/File.svg';

interface Props {
  msg: string;
  code: string;
  settlementId?: string;
}
const CreateSettlementErrorModal: React.FC<Props> = ({
  msg,
  code,
  settlementId,
}) => {
  const { closeModal } = useModal();
  const { push } = useRouter();
  const { t } = useTranslation('common');

  return (
    <div className='flex flex-col items-center'>
      {code === '#0003' ? (
        <div className='fkex fkex-col items-center'>
          <EmptyCard
            variant='icon'
            vector={<File />}
            message={
              // <p className='text-center'>
              //   {t(
              //     'issued-settlement-already-exists-for-supplier-crops-in-days'
              //   )}{' '}
              //   :
              //   <br />
              //   {msg.split('to').join(`${t('to')}`)}
              // </p>
              <p className='text-center'>
                {t('CREATE_SETTLEMENT#0003')} :
                <br />
                {msg.split(':')[1]}
              </p>
            }
            // directiveMessage={t('settlement-edit-work-days')}
          />
          <Button
            onClick={() => closeModal()}
            type='button'
            className='mt-24 py-9'
            size='full'
            variant='filled'
          >
            {t('back')}
          </Button>
        </div>
      ) : code === '#0001' ? (
        <div className='fkex fkex-col items-center'>
          <EmptyCard
            variant='icon'
            vector={<File />}
            message={t(
              'under-issued-settlement-already-exists-for-supplier-crops'
            )}
          />

          <Button
            onClick={() => closeModal()}
            type='button'
            className='mt-24 py-9'
            size='full'
            variant='text'
          >
            {t('back')}
          </Button>
          <Button
            onClick={() => {
              settlementId
                ? push(`/accounts/settlements/${settlementId}`)
                : null;
              closeModal();
            }}
            type='button'
            className='mt-24 py-9'
            size='full'
            variant='filled'
          >
            {t('show-settlement')}
          </Button>
        </div>
      ) : code === '#0002' || code === '#0004' ? (
        <div className='fkex fkex-col items-center'>
          <EmptyCard
            variant='icon'
            vector={<File />}
            message={
              <p className='text-center'>
                {t('there-are-no-payables-fully-approved-to-be-issued')} :
                <br />
                {msg.split('to').join(`${t('to')}`)}
              </p>
            }
          />
          <Button
            onClick={() => closeModal()}
            type='button'
            className='mt-24 py-9'
            size='full'
            variant='filled'
          >
            {t('back')}
          </Button>
        </div>
      ) : code === '#0008' ? (
        <div className='fkex fkex-col items-center'>
          <EmptyCard
            variant='icon'
            vector={<File />}
            message={
              <p className='text-center'>
                {t('there-are-no-payables-fully-approved-to-be-issued')} :
                <br />
                {msg.split('to').join(`${t('to')}`)}
              </p>
            }
          />
          <Button
            onClick={() => closeModal()}
            type='button'
            className='mt-24 py-9'
            size='full'
            variant='filled'
          >
            {t('back')}
          </Button>
        </div>
      ) : null}
    </div>
  );
};
export default CreateSettlementErrorModal;
